import _ from 'lodash';
import constants from '$$helpers/constants';
import numbersHelper from '$$helpers/numbers';
import BaselineGrid from '../baselines/grid';
import { getChildrenByTaskId } from '../helpers/ganttHelpers';
import rights from "../../../components/rights";

class Costs {
  #instance = null;

  init(instance) {
    this.#instance = instance;
  }

  getPriceValueForTask(task, isBaseline, baselineState, notFormatted = false) {
    if (task.type === this.#instance.config.types.button) {
      return '';
    }

    let totalPrice = 0;

    if (!task.gantt_id) {
      if (!this.#instance.config.multiview) {
        return '';
      }

      if (task.type === this.#instance.config.types.project) {
        totalPrice = this.getPriceForProjectTask(task);
      }
    } else if (task.type === this.#instance.config.types.project) {
      if (isBaseline) {
        const originalChildren = getChildrenByTaskId(this.#instance, task.id);

        _.each(originalChildren, child => {
          const baselineTask = baselineState ? _.find(baselineState.tasks, bt => bt.id === child.id) : BaselineGrid.baselinesTasks[child.id];

          if (baselineTask && baselineTask.type !== this.#instance.config.types.button) {
            // if (baselineTask.type !== this.#instance.config.types.project && baselineTask.resources && baselineTask.resources.length) {
            if (baselineTask.type !== this.#instance.config.types.project) {
              totalPrice += this.calculateCostChildTask(baselineTask);
            }
          }
        });
      } else {
        totalPrice = this.getPriceForProjectTask(task);
      }
    } else {
      if ((task.resources && task.resources.length) || !this.#instance.config.auto_budget) {
        totalPrice = this.calculateCostChildTask(task);
      }
    }

    if(!rights.project.hasCostRight(task.gantt_id)) return '';

    return notFormatted ? totalPrice : this.formatWithCurrency(totalPrice);
  }

  getActualCostValueForTask(task, notFormatted = false) {
    if (task.type === this.#instance.config.types.button) {
      return '';
    }

    if (!task.gantt_id && !this.#instance.config.multiview) {
      return '';
    }

    let resultCost = '';

    if (task.type === this.#instance.config.types.project) {
      let totalCost = this.calculateActualCostChildTask(task);

      this.#instance.eachTask(childTask => {
        if (childTask.type !== this.#instance.config.types.button) {
          totalCost += this.calculateActualCostChildTask(childTask);
        }
      }, task.id);

      resultCost = totalCost;
    } else {
      resultCost = this.calculateActualCostChildTask(task);
    }
    if(!rights.project.hasCostRight(task.gantt_id)) return '';
    return notFormatted ? resultCost : this.formatWithCurrency(resultCost);
  }

  getPriceForProjectTask(task) {
    let totalPrice = 0;

    this.#instance.eachTask(childTask => {
      if (childTask.type !== this.#instance.config.types.button) {

        if (childTask.type !== this.#instance.config.types.project && ((childTask.resources && childTask.resources.length) || !this.#instance.config.auto_budget)) {
          totalPrice += this.calculateCostChildTask(childTask);
        }
      }
    }, task.id);

    return totalPrice;
  }

  calculateCostChildTask(task) {
    let total = 0;

    if (this.#instance.config.auto_budget) {
      _.each(task.resources, resource => {
        const resourceData = this.#instance.ganttDataApi.getResourceById(resource.resource_id);
        const resourceSettingsOnProject = resourceData ? resourceData.resourceProjects?.find(o => o.projectId === task.gantt_id) : null;

        if (!resourceSettingsOnProject) {
          return;
        }

        if (resourceSettingsOnProject.type === constants.RESOURCE_COST_TYPE) {
          total += resource.value;
          return;
        }

        total += resource.value * resourceSettingsOnProject.cost;
      });
    } else {
      total += task.total_price || 0;
    }

    total = Math.round(total * 100) / 100;

    return total;
  }

  calculateActualCostChildTask(task) {
    let result = 0;

    if (this.#instance.config.auto_budget) {
      const taskLogsData = this.#instance.ganttDataApi.getTimeLogsByParams(task.gantt_id, task.id);

      if (taskLogsData) {
        _.each(taskLogsData.logs, log => {
          const resourceData = this.#instance.ganttDataApi.getResourceById(log.resource_id);
          const resourceSettingsOnProject = resourceData ? resourceData.resourceProjects?.find(o => o.projectId === task.gantt_id) : null;

          if (!resourceSettingsOnProject) {
            return;
          }

          if (resourceSettingsOnProject.type === constants.RESOURCE_TIME_TYPE) {
            result += (log.time / 60) * resourceSettingsOnProject.cost;
          }
        });
      }

      if (!task.resources || !task.resources.length || !task.progress) {
        return result;
      }

      task.resources.forEach(resource => {
        const resourceData = this.#instance.ganttDataApi.getResourceById(resource.resource_id);
        const resourceSettingsOnProject = resourceData ? resourceData.resourceProjects?.find(o => o.projectId === task.gantt_id) : null;

        if (!resourceSettingsOnProject) {
          return;
        }

        if (resourceSettingsOnProject.type === constants.RESOURCE_TIME_TYPE) {
          const resourceData = this.#instance.ganttDataApi.getResourceById(resource.resource_id);

          if (!resourceData.userId) {
            result += resource.value * resourceSettingsOnProject.cost * task.progress;
          }
        }

        if (resourceSettingsOnProject.type === constants.RESOURCE_ITEM_TYPE) {
          result += resource.value * resourceSettingsOnProject.cost * task.progress;
        }

        if (resourceSettingsOnProject.type === constants.RESOURCE_COST_TYPE) {
          result += resource.value * task.progress;
        }
      });
    } else {
      result += task.actual_cost || 0;
    }

    result = Math.round(result * 100) / 100;

    return result;
  }

  formatWithCurrency(number) {
    const currencySign = this.#instance.ganttDataApi.isCurrencyEnabled()
      ? GT.currency.find(item => item.ID === this.#instance.ganttDataApi.getCurrency())?.VALUE || ''
      : '';

    return currencySign + numbersHelper.getFormatted(number);
  }
}

export default new Costs();
